import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { Directive, OnInit, Input} from '@angular/core';
@Directive({
  selector: '[appTextAreaPattern]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: TextAreaPatternValidator, multi: true }
  ]
})
export class TextAreaPatternValidator implements Validator {
@Input() pattern: string;
  validate(c: AbstractControl) {
      if (!(new RegExp(this.pattern).test(c.value))) {
          return { 'pattern': true};
      }
      return null;
  }
}
